import { LogManager } from '../../../../common/port/log/log.manager.port';
import { AccountAppCategoryMetricsPerAppAggregateRootMapper } from '../../../../infrastructure/mappers/org-metrics/apps/get-account-app-category-metrics-per-app.aggregate-root.mapper';
import { GetAccountAppCategoryMetricsPerAppRequestDto } from '../../../dtos/org-metrics/apps/get-account-app-category-metrics-per-app.request.dto';
import { GetAccountAppCategoryMetricsPerAppResponseDto } from '../../../dtos/org-metrics/apps/get-account-app-category-metrics-per-app.response.dto';
import { GetAccountAppCategoryMetricsPerAppQuery } from '../../../queries/org-metrics/apps/get-account-app-category-metrics-per-app.query';

export class GetAccountAppCategoryMetricsPerAppController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetAccountAppCategoryMetricsPerAppQuery,
    protected readonly mapper: AccountAppCategoryMetricsPerAppAggregateRootMapper
  ) {}

  async get(
    props: GetAccountAppCategoryMetricsPerAppRequestDto
  ): Promise<GetAccountAppCategoryMetricsPerAppResponseDto> {
    try {
      const result = await this.query.execute(props);

      return result.map((entity) => {
        return this.mapper.toResponse(entity);
      });
    } catch (error) {
      throw new Error(
        `GetAccountAppCategoryMetricsPerAppController.get encountered an error ${error}`
      );
    }
  }
}
